<template>
  <div class="user-wrapper">
    <van-row class="info" type="flex" align="center">
      <van-col class="avatar-wrapper">
        <div class="avatar">
          <div v-if="vips.length" class="vip-img-label" />
          <lazy-component class="lazy-component">
            <van-image
              round
              width="100%"
              height="100%"
              fit="fill"
              :src="user.avatar || nullAvatar"
            />
          </lazy-component>
        </div>
      </van-col>
      <van-col class="info-wrapper">
        <h1 class="name">{{ user.nickname }}</h1>
        <p class="credits">积分余额 <span class="active">{{ credits.total }}</span></p>
      </van-col>
      <van-col v-if="organization.creditAwards.everyday" class="button-wrapper">
        <template v-if="credits.drawedToday">
          <van-button class="button deactivated-button">
            已完成签到
          </van-button>
        </template>
        <template v-else>
          <van-button class="button activated-button" @click="updateCredits">
            签到领积分
          </van-button>
        </template>
      </van-col>
    </van-row>
    <div class="vips-wrapper">
      <p class="vips-label">已拥有高级学员徽章 <span class="active">{{ vips.length }}</span> 个</p>
      <div class="vips">
        <template v-for="item in vips">
          <div :key="item.id" :class="['vip', 'vip-active']" @click="checkVipHandler(item)">
            <p class="vip-title">{{ item.name }}</p>
            <p class="vip-detail">{{ item.detail }}</p>
            <p class="end-date">{{ item.expiredAt | dateFormat }} 前有效</p>
          </div>
        </template>
      </div>
    </div>
    <div class="my-stuff">
      <van-row
        class="stuff-wrapper"
        type="flex"
        align="center"
        @click="$router.push({
          name: 'orders'
        })"
      >
        <van-col class="img-wrapper order" />
        <van-col class="title">
          我的订单
        </van-col>
        <van-icon name="arrow" class="icon" />
      </van-row>
      <van-row
        class="stuff-wrapper"
        type="flex"
        align="center"
        @click="$router.push({
          name: 'collects'
        })"
      >
        <van-col class="img-wrapper collect" />
        <van-col class="title">
          我的收藏
        </van-col>
        <van-icon name="arrow" class="icon" />
      </van-row>
    </div>
    <div class="logout-wrapepr">
      <van-button class="logout" @click="logoutHandler">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { clearToken, User, Vip } from '@/api'
import nullAvatar from '@/assets/images/avatar.png'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'User',
  mixins: [mixinWxShare],
  data: () => ({
    vips: [],
    nullAvatar
  }),
  computed: {
    ...mapGetters(['organization', 'user', 'credits'])
  },
  async mounted () {
    try {
      const { user } = await User.get()
      const { vips } = await Vip.open()
      this.vips = vips
      this.updateUser(user)
      this.checkCredits()
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapActions(['updateUser', 'checkCredits', 'updateCredits', 'updateVip']),
    checkVipHandler (vip) {
      this.updateVip(vip)
      this.$router.push({
        name: 'vip-id',
        params: {
          id: vip.id
        },
        query: {
          'return_to_url': this.$route.fullPath
        }
      })
    },
    logoutHandler () {
      clearToken()
      this.$router.replace({
        name: 'login'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.user-wrapper {
  @include bg-image-png('/teacher/home-bg');
  @include mh-bgc(inherit, #fff);
  background-size: 100% 100vh;
  background-attachment: fixed;
  background-position: left top;
  padding: 62px 16px 16px;
  box-sizing: border-box;
  .info {
    .avatar-wrapper {
      position: relative;
      .avatar {
        font-size: 0;
        border-radius: 50%;
        border: 2px solid $color-text-active;
        .lazy-component {
          @include wh(70px, 70px);
        }
        &.vip {
        }
      }
      .vip-img-label {
        @include wh(100px, 100px);
        @include bg-image-png('/vip/avatar-active');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .info-wrapper {
      @include wh(180px, inherit);
      padding-left: 16px;
      .name {
        @include sc($font-size-xlg, $color-text-heavy);
        @include lw(18px, 500);
        padding-bottom: 13px;
      }
      .credits {
        @include sc($font-size-base, $color-text-light);
        @include lw(12px, inherit);
        .active {
          padding: 5px;
          color: $color-text-active;
        }
      }
    }
    .button-wrapper {
      .button {
        @include wh(96px, 36px);
        @include lw(36px, inherit);
        &.deactivated-button {
          @include lg-radius(#ECCEA2, #E7B170, 4px);
          @include normal-button(96px, 36px);
          border: 1px solid #999999;
          background: #999999;
        }
        &.activated-button {
          @include lg-radius(#ECCEA2, #E7B170, 4px);
          @include normal-button(96px, 36px);
        }
      }
    }
  }
  .vips-wrapper {
    padding-top: 26px;
    .vips-label {
      @include sc($font-size-md, $color-text-heavy);
      .active {
        color: $color-text-active;
      }
    }
    .vips {
      display: flex;
      flex-wrap: nowrap;
      padding: 32px 0;
      overflow-x: scroll;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        display: none !important;
        width: 0px;
        height: 0px;
      }
      .vip {
        @include wh(150px, 94px);
        min-width: 150px;
        max-width: 150px;
        padding: 16px;
        position: relative;
        & + .vip {
          margin-left: 8px;
        }
        &::before {
          @include wh(118px, 78px);
          content: " ";
          position: absolute;
          top: 28px;
          left: 50%;
          transform: translateX(-50%);
        }
        &-active {
          @include bg-image-png('/vip/bg-active');
          color: #BF8736;
          background-size: cover;
          &::before {
            @include lg-shadow(#FFE9C2, #C89B40, 4px);
          }
          &::after {
            @include wh(64px, 77px);
            @include bg-image-png('/vip/medal-active');
            content: " ";
            position: absolute;
            top: -23px;
            right: -7px;
            background-size: cover;
          }
        }
        &-expired {
          @include bg-image-png('/vip/bg-expired');
          background-size: cover;
          &::before {
            @include lg-shadow(#D9D9D9, #A2A2A2, 4px);
          }
          &::after {
            @include wh(64px, 77px);
            @include bg-image-png('/vip/medal-expired');
            content: " ";
            position: absolute;
            top: -23px;
            right: -7px;
            background-size: cover;
          }
        }
        &-title {
          @include lw(16px, 500);
          @include ellipsis(1, 16px);
          font-size: $font-size-lg;
          margin-bottom: 12px;
        }
        &-detail {
          @include ellipsis(1, 14px);
          font-size: $font-size-base;
          margin-bottom: 8px;
        }
        .end-date {
          @include ellipsis(1, 14px);
          font-size: $font-size-base;
        }
      }
    }
  }
  .my-stuff {
    .stuff-wrapper {
      padding: 11px 16px;
      box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);
      border-radius:4px;
      background-color: #fff;
      & + .stuff-wrapper {
        margin-top: 16px;
      }
      .img-wrapper {
        @include wh(30px, 30px);
        background-position: center;
        background-size: cover;
        &.order {
          @include bg-image-png('/user/order');
        }
        &.collect {
          @include bg-image-png('/user/collect');
        }
      }
      .title {
        @include wh(270px, 22px);
        @include sc($font-size-lg, $color-text-medium);
        padding-left: 16px;
      }
    }
  }
  .logout-wrapepr {
    @include bottomfix(82px);
    @include wh(343px, inherit);
    .logout {
      @include wh(100%, 100%);
      @include lg-radius(#FF6767, #FF0000);
      @include sc($font-size-lg, #fff);
      margin: auto;
      height: 39px;
      line-height: 39px;
      border: 0;
    }
    &::before {
      @include lg-shadow(#FF3333, #FF3333);
      @include wh(300px, 30px);
      content: " ";
      position: absolute;
      left: 16px;
      top: 10px;
    }
  }
}
</style>
